import styled, {css} from 'styled-components';

type TOptionProps = TTheme & {
  disabled?: boolean;
  readOnly?: boolean;
  selected?: boolean;
  hoverDisabledStyle?: boolean;
};

const getOptionStyle = ({
  disabled,
  selected,
  readOnly,
  hoverDisabledStyle,
  theme: {palette, branding},
}: TOptionProps) => {
  if (disabled) {
    return css`
      color: ${palette.grey300};

      &:hover {
        cursor: not-allowed;
      }
    `;
  }

  if (readOnly) {
    return css`
      color: ${palette.grey300};
    `;
  }

  if (selected) {
    return css`
      cursor: pointer;
      color: ${branding.content.primary};
      background-color: ${palette.grey200};
    `;
  }

  return css`
    color: ${branding.content.primary};
    background-color: ${branding.backgrounds.primary};

    ${!hoverDisabledStyle &&
    css`
      &:hover {
        color: ${branding.content.primary};
        background-color: ${branding.backgrounds.secondary};
        cursor: pointer;
      }
    `}
  `;
};

export const Option = styled.div<TOptionProps>`
  display: flex;
  align-items: center;
  padding: ${({theme: {spacing}}) => `${spacing.s2} ${spacing.s4}`};
  white-space: nowrap;
  ${getOptionStyle}
`;
